import { useForm } from "react-hook-form";
import { useGetAppDisplayConfig, useUpdateAppDisplayConfig } from "../../../queries/homepageOrganizer";
import { useEffect, useState } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ActiveStatus from "../../../components/Common/ActiveStatus";
import { ActionButton } from "../../../components/Forms/ActionButton";

const RewardsPageController = () => {

    const { data, isPending } = useGetAppDisplayConfig();
    const { mutateAsync: updateAppDisplayConfig, isPending: isUpdatingAppDisplayConfig } = useUpdateAppDisplayConfig();

    const [showProductRedemption, setShowProductRedemption] = useState(false);
    const [showTreePlantation, setShowTreePlantation] = useState(false);
    const [showPointDonation, setShowPointDonation] = useState(false);

    const handleUpdateAppDisplayConfig = async (e) => {
        e.preventDefault();
        await updateAppDisplayConfig({
            id: data._id,
            showProductRedemption: showProductRedemption,
            showTreePlantation: showTreePlantation,
            showPointDonation: showPointDonation,
        }, {
            onSuccess: () => {
                toast.success("Configurations updated successfully");
            },
            onError: (error) => {
                toast.error(`Error updating configurations: ${error.message}`);
            }
        });
    }

    useEffect(() => {
        if (data) {
            setShowProductRedemption(data.showProductRedemption);
            setShowTreePlantation(data.showTreePlantation);
            setShowPointDonation(data.showPointDonation);
        }
    }, [data]);

    if (isPending || isUpdatingAppDisplayConfig) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="loader">Loading...</div>
            </div>
        );
    }

    return (
        <div className='bg-white shadow-md rounded-lg p-5 flex flex-col items-start gap-2'>
            <h2 className="text-2xl text-primary font-bold cursor-pointer">Rewards Section Display</h2>
            <form onSubmit={handleUpdateAppDisplayConfig} className="space-y-4 w-full">
                <div className="flex flex-col items-start gap-2 mt-3">
                    <ActiveStatus
                        isCreateForm={false}
                        active={showProductRedemption}
                        setActive={setShowProductRedemption}
                        label={"Show Product Redemption"}
                    />
                    <ActiveStatus
                        isCreateForm={false}
                        active={showTreePlantation}
                        setActive={setShowTreePlantation}
                        label={"Show Tree Plantation"}
                    />
                    <ActiveStatus
                        isCreateForm={false}
                        active={showPointDonation}
                        setActive={setShowPointDonation}
                        label={"Show Point Donation"}
                    />
                </div>
                <div className="flex justify-end mt-4">
                    <ActionButton
                        variant="submit"
                        text="Update Configurations"
                        disabled={isUpdatingAppDisplayConfig}
                        isSubmit={true}
                    />
                </div>
            </form>
            <ToastContainer
                position="top-right"
            />
        </div>
    );
}

export default RewardsPageController;